module.exports = __webpack_public_path__ + "img/autumn-top.00f1ac04.png";